import { render, staticRenderFns } from "./questionShow.vue?vue&type=template&id=ab369752&scoped=true"
import script from "./questionShow.vue?vue&type=script&lang=js"
export * from "./questionShow.vue?vue&type=script&lang=js"
import style0 from "./questionShow.vue?vue&type=style&index=0&id=ab369752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab369752",
  null
  
)

export default component.exports